import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import i18n from '../i18n'
import style from './CompanyStats.less'

class CompanyStats extends Component {

    static propTypes = {
    }

    render() {
        const {dispatch, range} = this.props

        return (
            <div className={style.default}>
                <h4>{range.count} {i18n.companies}</h4>
            </div>
        )
    }
}

CompanyStats = connect((state) => ({
    range: state.company.range
}))(CompanyStats)

export default CompanyStats


// WEBPACK FOOTER //
// ./lib/company/components/CompanyStats.js